
import { pdf } from '@react-pdf/renderer';
import { sendEmail } from '../../Email/EmailSend';
import PureSeniorCollegePension from './pdfSenior/purePDFPensionSr';
import PureHighSchoolPension from './pdfHighSchool/purePDFPensionHS';
  

export async function CallMailDetails(form, result) {
 // Generate PDF
 const text = `
 Dear ${result.employeeName},

Thank you for submitting your form at Himanshu Salary Corner. We have successfully processed your request, and your result is now available.

Please find attached a PDF document containing your result according to your form submission details. Kindly review the document, and if you have any questions or require further assistance, feel free to reach out to us.

Company Details:
📍 Himanshu Salary Corner
🏢 159 Guruwar Peth, Satara
📞 +91 9529402894

We appreciate your trust in our services and look forward to assisting you again in the future.

Best regards,
Himanshu Salary Corner
📩 admin@himanshusalarycorner.in
🌐 himanshusalarycorner.in
 `;
if(form === 'sr'){
  const pdfBlob = await pdf(<PureSeniorCollegePension result={result} />).toBlob();
  const subject = `Pension Case: ${result.employeeName}`;
  const pdfName = `Pension_Case_Senior_College_${result.employeeName}.pdf`;
  sendEmail(result.email, subject, pdfBlob, text, pdfName);
}

if(form === 'hs'){
  const pdfBlob = await pdf(<PureHighSchoolPension result={result} />).toBlob();
  const subject = `Pension Case: ${result.employeeName}`;
  const pdfName = `Pension_Case_High_School_${result.employeeName}.pdf`;
  sendEmail(result.email, subject, pdfBlob, text, pdfName);
}

}
